// Placeholder admin pages
export const AdminReports = () => (
  <div data-testid="admin-reports">
    <h1 className="text-3xl font-bold text-white mb-4">Reports</h1>
    <p className="text-neutral-400">Advanced reporting coming soon...</p>
  </div>
);
